import React from 'react';
import { Dropdown, Menu } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { setLocale } from '@/locales';
import { useIntl } from 'react-intl';

const LanguageSetting = props => {
  const intl = useIntl();

  const languageData = [
    { key: 'zh-CN', label: '中文' },
    { key: 'en-US', label: 'English' },
  ];
  const onClick = ({ key }) => {
    setLocale(key);
  };
  const menu = (
    <Menu items={languageData} onClick={({ key }) => setLocale(key)} />
  );
  return (
    <Dropdown overlay={menu} arrow={true} {...props}>
      <span>
        <GlobalOutlined style={{ fontSize: '16px' }} />
        {intl.formatMessage({ id: 'layout.lang' })}
        <DownOutlined
          style={{ marginLeft: 4, fontSize: 10, color: '#9f9f9f' }}
        />
      </span>
    </Dropdown>
  );
};
export default LanguageSetting;
